/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccommodationBookingObjectContentModelContentType = typeof AccommodationBookingObjectContentModelContentType[keyof typeof AccommodationBookingObjectContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationBookingObjectContentModelContentType = {
  accommodationBookingObject: 'accommodationBookingObject',
} as const;
